/**
 *
 * @class {SectionUserContent.My}
 * @extends {SectionUserContentBase}
 */
SectionUserContent.My = Class(
	/**
	 * @lends {SectionUserContent.My#}
	 */
	{
		bodyClass: 'small-nav user-content-my',

		_draw: function() {
			if (this.url.get.is('success')) {
				mkE({
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'add-success',
							els: [
								mkELottie({
										tag: 'div',
										className: 'lottie'
									}, {
										path: '/assets/lottie/trash_lm65wict.json',
										loop: false
									}
								),
								{
									tag: 'h4',
									text: D.Lang.get('user-content-new.addSuccess')
								},
								{
									tag: 'p',
									text: D.Lang.get('user-content-new.addSuccessDescr')
								}
							]
						}
					]
				}).append(this._mainContentNode);
			}

			this._drawMyTasks();
		},

		_drawMyTasks: function() {
			this.rpc.send('getMyContent', {
				event_id: SectionUserContent.EVENT_ID
			}, this._onTasks);
		},

		_tasksTypesNodes: {},

		_addTaskGroup(type) {
			mkE({
				tag: 'div',
				className: 'task-group',
				els: [
					{
						tag: 'h5',
						text: D.Lang.get(`user-content-new.types.${type}.title`) +
							': '
					},
					this._tasksTypesNodes[type] = mkE({
						tag: 'div',
						className: 'tasks'
					})
				]
			}).append(this._tasksNode);
		},

		_onTasks: function(data) {
			if (data.userTaskLimit >= 0 && data.total >= data.userTaskLimit) {
				mkE({
					tag: 'div',
					className: 'container',
					els: [
						{
							tag: 'div',
							className: 'add-success',
							els: [
								{
									tag: 'div',
									className: 'lottie add-success__limit'
								},
								{
									tag: 'h4',
									text: D.Lang.get('user-content-new.limit.descr').replaceAll('%MAX%', data.userTaskLimit)
								}
							]
						}
					]
				}).append(this._mainContentNode);
			}
			mkE({
				tag: 'div',
				className: 'container user-content-add',
				els: [
					{
						tag: 'div',
						className: 'title',
						text: D.Lang.get('user-content-new.myTasksTitle')
					},
					{
						tag: 'div',
						className: 'description',
						text: D.Lang.get('user-content-new.myTasksDescription')
					},
					this._tasksNode = mkE({
						tag: 'div',
						className: 'task-groups'
					})
				]
			}).append(this._mainContentNode);
			this._tasksTypesNodes = {};
			// Order
			const taskTypes = ['image', 'question'];
			for (let i = 0; i < taskTypes.length; i++) {
				const taskType = taskTypes[i];
				this._addTaskGroup(taskType);
			}
			if (data.tasks) {
				for (let i = 0, l = data.tasks.length; i < l; i++) {
					const task = data.tasks[i];
					if (!this._tasksTypesNodes[task.type]) {
						this._addTaskGroup(task.type);
					}
					new SectionUserContent.My.TaskPreview(task).append(
						this._tasksTypesNodes[task.type]
					);
				}
			}
			this.ready();
		}
	},
	SectionUserContentBase
);

SectionUserContent.My.TaskPreview = Class(
	/**
	 * @lends {SectionUserContent.My.TaskPreview#}
	 */
	{
		__construct: function(data) {
			this.data = data;

			this.node = mkE({
				tag: 'div',
				className: `task task-${this.data.type}`,
				els: [
					{
						tag: 'div',
						className: 'task-added',
						text: D.Lang.get('user-content-new.task.event').replace('%EVENT_TITLE%', this.data.event.title)
					},
					{
						tag: 'div',
						className: 'task-added',
						text: D.Lang.get('user-content-new.task.added').
							replace('%DATE%', new D.Date(this.data.ts).format(
								D.Lang.get('user-content-new.task.added.date-format')))
					},
					{
						tag: 'div',
						className: 'task-added',
						text: D.Lang.get('user-content-new.task.plays').replace('%PLAYS%', this.data.plays)
					},
					this._contentNode = mkE({
						tag: 'div',
						className: 'task-content'
					}),
					this._footerNode = mkE({
						tag: 'div',
						className: 'task-footer'
					})
				]
			});

			switch (this.data.type) {
				case 'image':
					this._drawImage();
					break;
				case 'question':
					this._drawQuestion();
					break;
				default:
					return;
			}
			this._drawFooter();
		},

		_drawImage: function() {
			let item = this.data;
			let els = [
				{
					tag: 'div',
					className: 'images',
					els: [
						{
							tag: 'div',
							className: 'image',
							style: {
								backgroundImage: `url('${item.mapImage}')`
							},
							onclick: this._showImage.bind(this, item.mapImage)
						},
						{
							tag: 'div',
							className: 'image',
							style: {
								backgroundImage: `url('${item.image.place.image.large}')`
							},
							onclick: this._showImage.bind(this, item.image.place.image.large)
						},
						{
							tag: 'div',
							className: 'image',
							style: {
								backgroundImage: `url('${item.image.object.image.large}')`
							},
							onclick: this._showImage.bind(this, item.image.object.image.large)
						}
					]
				}
			];
			mkE.appendTypeElement(this._contentNode, els);
		},

		_drawQuestion: function() {
			let item = this.data;
			let els = [
				{
					tag: 'div',
					className: 'images',
					els: [
						{
							tag: 'div',
							className: 'image',
							style: {
								backgroundImage: `url('${item.mapImage}')`
							},
							onclick: this._showImage.bind(this, item.mapImage)
						},
						{
							tag: 'div',
							className: 'image',
							style: {
								backgroundImage: `url('${item.image.place.image.large}')`
							},
							onclick: this._showImage.bind(this, item.image.place.image.large)
						}
					]
				},
				{
					tag: 'div',
					className: 'question',
					text: item.question.question
				},
				{
					tag: 'div',
					className: 'answers',
					els: (() => {
						let els = [];
						for (let i = 0; i < item.question.wrongAnswers.length; i++) {
							const wrongAnswer = item.question.wrongAnswers[i];
							els.push({
								tag: 'div',
								text: wrongAnswer
							});
						}
						els.splice(item.id % 4, 0, [
							{
								tag: 'div',
								className: 'correct',
								text: item.question.answer
							}
						]);
						return els;
					})()
				}
			];
			mkE.appendTypeElement(this._contentNode, els);
		},

		_drawFooter: function() {
			const statusStrings = [
				'review',
				'approved',
				'declined'
			];
			const status = statusStrings[this.data.status];
			let reason = null;
			let buttons = [
				{
					tag: 'div',
					className: `button button-status button-status-${status}`,
					text: D.Lang.get(`user-content-new.statusFilters.${status}`)
				}
			];
			if (this.data.status === 2 && this.data.reason) {
				reason = {
					tag: 'div',
					className: 'task-decline-reason',
					els: [
						{
							tag: 'strong',
							text: D.Lang.get('user-content-new.task.declined_reason') + ': '
						},
						this.data.reason
					]
				};
			}
			if (this.data.status !== 1) {
				buttons.push(
					{
						tag: 'a',
						className: 'button button-edit',
						href: D.url('user-content/edit/' + this.data.id),
						text: D.Lang.get('user-content-new.editTask')
					},
					{
						tag: 'a',
						className: 'button button-trash',
						onclick: this._trash,
						els: [
							D.svgIcon('trash')
						]
					}
				);
			}
			mkE.appendTypeElement(this._footerNode, [
				reason,
				{
					tag: 'div',
					className: 'buttons',
					els: buttons
				}
			]);
		},

		_trash() {
			let modal = new T.Popup({
				className: 'popup-dialogue'
			});
			let els = [
				mkELottie({
						tag: 'div',
						className: 'lottie'
					}, {
						path: '/assets/lottie/success_lm6dyjz2.json',
						loop: false
					}
				),
				{
					tag: 'h4',
					text: D.Lang.get('user-content-new.task.delete.title')
				},
				{
					tag: 'p',
					text: D.Lang.get('user-content-new.task.delete.description')
				},
				{
					tag: 'div',
					className: 'buttons',
					els: [
						{
							tag: 'button',
							className: 'button button-pink',
							text: D.Lang.get('delete'),
							onclick: () => {
								this._deleteTask();
								modal.close();
							}
						},
						{
							tag: 'button',
							className: 'button button-link',
							text: D.Lang.get('cancel'),
							onclick: function() {
								modal.close();
							}
						}
					]
				}
			];
			modal.setContent(els);
			modal.open();
		},

		_deleteTask() {
			this.rpc.send('removeUserContent', {
				id: this.data.id
			}, this._deleteTaskRe);
		},

		_deleteTaskRe() {
			this.node.remove();
		},

		_showImage(url) {
			T.Popup.Gallery.open([url]);
		}

	},
	mkE.Base
);

// Temp deprecated
// SectionUserContent.My.Filters;